import reduxStore from 'redux/store'
import {compile} from 'path-to-regexp';
import {setMenuOpen} from 'redux/actions';
import querystring from 'querystring';

export const createPath = (route, params) => compile(route)(params);

const purchaserBaseRoute = "/react"
const purchaserBaseRoute2 = "/purchaser"
const contractorBaseRoute = "/contractor"

const root = {
    BASE: '/',
}

const buyerPaths = {
    BUYER_INIT: purchaserBaseRoute,
    MY_PROCEDURE: purchaserBaseRoute + '/my-procedure',
    FAQ: purchaserBaseRoute + '/faq',
    PURCHASER_INIT: purchaserBaseRoute2,
    PURCHASING_GROUP: purchaserBaseRoute2 + '/purchasing-group',
    ANNUAL_REPORT: purchaserBaseRoute2 + '/annual-report',
    ADMIN: purchaserBaseRoute2 + '/admin',
    DEMAND: purchaserBaseRoute2 + '/demand',
}


const ctrPaths = {
    CTR_INIT: contractorBaseRoute,
    CTR_DEMAND: contractorBaseRoute + '/demand',
}

const ctrDemand = {
	old: {
		CTR_DEMAND_CORRESPONDENCE_ID: ctrPaths.CTR_DEMAND + '/correspondence/:id(\\d+)'
	},
	steps: {
        CTR_DEMAND_ID: ctrPaths.CTR_DEMAND + '/:id(\\d+)',
        CTR_DEMAND_ID_CORRESPONDENCE: ctrPaths.CTR_DEMAND + '/:id(\\d+)/correspondence',
        CTR_DEMAND_ID_OFFER: ctrPaths.CTR_DEMAND + '/:id(\\d+)/offer',
        CTR_DEMAND_ID_OFFER_STAGE: ctrPaths.CTR_DEMAND + '/:id(\\d+)/offer/stage',
        CTR_DEMAND_ID_OFFER_STAGE_ID: ctrPaths.CTR_DEMAND + '/:id(\\d+)/offer/stage/:stageId(\\d+)',
        CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION:ctrPaths.CTR_DEMAND + '/:id(\\d+)/offer/stage/:stageId(\\d+)/:section'
	}
}


const myProcedureSteps = {
    MP_1: buyerPaths.MY_PROCEDURE + '/1',
    MP_2: buyerPaths.MY_PROCEDURE + '/2',
    MP_3: buyerPaths.MY_PROCEDURE + '/3',
    MP_4: buyerPaths.MY_PROCEDURE + '/4',
    MP_CORRESPONDENCE: buyerPaths.MY_PROCEDURE + '/correspondence',
    MP_EMAIL_LIST: buyerPaths.MY_PROCEDURE + '/email-list',
    MP_NATIONAL_NOTICE: buyerPaths.MY_PROCEDURE + '/nationalNotice',
}

const myProcedureStepsTabsEdit = {
	MP_1_ID: myProcedureSteps.MP_1 + '/:id(\\d+)?',
	MP_2_ID: myProcedureSteps.MP_2 + '/:id(\\d+)?',
	MP_3_ID: myProcedureSteps.MP_3 + '/:id(\\d+)?',
	MP_4_ID: myProcedureSteps.MP_4 + '/:id(\\d+)?',
	MP_CORRESPONDENCE_ID: myProcedureSteps.MP_CORRESPONDENCE + '/:id(\\d+)',
	MP_EMAIL_LIST_ID: myProcedureSteps.MP_EMAIL_LIST + '/:id(\\d+)',
	MP_NATIONAL_NOTICE_FORM_TYPE_ID: myProcedureSteps.MP_NATIONAL_NOTICE + '/:formType/:id',
}


const myProcedure = {
    steps: {
        ...myProcedureSteps,
        ...myProcedureStepsTabsEdit,
    }
}

const annualReport = {
    MP_ANNUAL_REPORT: buyerPaths.ANNUAL_REPORT,
    MP_ANNUAL_REPORT_YEAR_LIST: buyerPaths.ANNUAL_REPORT + '/year/:year(\\d+)',

    MP_ANNUAL_REPORT_REPORT: buyerPaths.ANNUAL_REPORT + '/report',
    MP_ANNUAL_REPORT_REPORT_ID: buyerPaths.ANNUAL_REPORT + '/report/:id(\\d+)',
    MP_ANNUAL_REPORT_REPORT_ID_TABLE: buyerPaths.ANNUAL_REPORT + '/report/:id(\\d+)/:table',
}

const purchasingGroup = {
    //bez kontekstu grupy zakupowej
    MP_PURCHASING_GROUP: buyerPaths.PURCHASING_GROUP,
    MP_PURCHASING_GROUP_LIST: buyerPaths.PURCHASING_GROUP + '/list',
    MP_PURCHASING_GROUP_MEMBER_LIST: buyerPaths.PURCHASING_GROUP + '/member/list',
    MP_PURCHASING_GROUP_TEMPLATES: buyerPaths.PURCHASING_GROUP + '/templates',
    MP_PURCHASING_GROUP_TEMPLATES_LIST: buyerPaths.PURCHASING_GROUP + '/templates/list',
    MP_PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID: buyerPaths.PURCHASING_GROUP + '/templates/template/:id(\\d+)',

    //kontekst konkretnej rejestracji
    MP_PURCHASING_GROUP_GROUP: buyerPaths.PURCHASING_GROUP + '/group',
    MP_PURCHASING_GROUP_GROUP_ID: buyerPaths.PURCHASING_GROUP + '/group/:id(\\d+)',
    MP_PURCHASING_GROUP_GROUP_ID_EMAIL_LIST: buyerPaths.PURCHASING_GROUP + '/group/:id(\\d+)/email-list',
    MP_PURCHASING_GROUP_GROUP_ID_STAGE: buyerPaths.PURCHASING_GROUP + '/group/:id(\\d+)/stage',
    MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR: buyerPaths.PURCHASING_GROUP + '/group/:id(\\d+)/stage/:stage(\\d+)',
    MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR_SECTION: buyerPaths.PURCHASING_GROUP + '/group/:id(\\d+)/stage/:stage(\\d+)/:section',
}

const purchaserDemand = {
    PURCHASER_DEMAND_ID: buyerPaths.DEMAND + '/:id(\\d+)',
    PURCHASER_DEMAND_ID_OFFER: buyerPaths.DEMAND + '/:id(\\d+)/offer',
    PURCHASER_DEMAND_ID_PREVIEW: buyerPaths.DEMAND + '/:id(\\d+)/preview',
    PURCHASER_DEMAND_ID_PREVIEW_ID_STAGE_ID_SECTION: buyerPaths.DEMAND + '/:id(\\d+)/preview/stage/:stageId(\\d+)/:section',
    PURCHASER_DEMAND_ID_OFFER_CONTRACTOR: buyerPaths.DEMAND + '/:id(\\d+)/offer/contractor',
    PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID: buyerPaths.DEMAND + '/:id(\\d+)/offer/contractor/:contractorDepartmentId(\\d+)',
    PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE: buyerPaths.DEMAND + '/:id(\\d+)/offer/contractor/:contractorDepartmentId(\\d+)/stage',
    PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID: buyerPaths.DEMAND + '/:id(\\d+)/offer/contractor/:contractorDepartmentId(\\d+)/stage/:stageId(\\d+)',
    PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID_SECTION: buyerPaths.DEMAND + '/:id(\\d+)/offer/contractor/:contractorDepartmentId(\\d+)/stage/:stageId(\\d+)/:section'
}


const admin = {
    ADMIN_REGISTRATIONS: buyerPaths.ADMIN + '/registrations',
    ADMIN_REGISTRATIONS_LIST: buyerPaths.ADMIN + '/registrations/list',
    ADMIN_REGISTRATION_ID: buyerPaths.ADMIN + '/registrations/:id',
}


const matchOpenDrawerMenu = [
    root.MY_PROCEDURE
]

const matchOpenDrawerMenuNotExact = []

export const setMenuOpenOnPath = (path = window.location.pathname) => {
    const {store} = reduxStore.getState()
    let open = matchOpenDrawerMenu.includes(path);
    for (let i in matchOpenDrawerMenuNotExact) {
        const item = matchOpenDrawerMenuNotExact[i];
        if (path.startsWith(item)) {
            open = true;
            break;
        }
    }
    if (store.isMenuOpen === open) return;

    reduxStore.dispatch(
        setMenuOpen(open)
    )
}

export const redirect = (path, state) => {
    const { store } = reduxStore.getState()
    store.redirect(path, state)
	setMenuOpenOnPath(path)
}

export const redirectWithoutHistory = (path, state) => {
	const { store } = reduxStore.getState()
	store.redirectReplace(path, state)
    setMenuOpenOnPath(path)
}

export const setSearchObj = searchObj => {
    const {store} = reduxStore.getState()
    const search = querystring.stringify(searchObj)
    const path = window.location.pathname;
    store.redirect(`${path}?${search}`)
}

export const redirectWithSearch = (path, searchObj) => {
    const search = querystring.stringify(searchObj)
    redirect(`${path}?${search}`)
}


export default {
    ...root,
    ...buyerPaths,
    ...ctrPaths,

    myProcedure,
    purchaserDemand,
    purchasingGroup,
    annualReport,
    admin,

    //ctr... dla wykonawcy, reszta dla zamawiającego
    ctrDemand,

    redirectWithoutHistory,
    redirect,
    redirectWithSearch,
    createPath,
    setSearchObj,
    setMenuOpenOnPath,
    baseRoute: purchaserBaseRoute
}